export default "__VITE_ASSET__CcBe19yi__"